import {copy} from '../../../../../../util/fieldscopy'
import {FormSectionType} from '../../../../../blocks/FormBlock'

const commentsData: FormSectionType = {
	id: 6,
	parent_id: 2,
	channel: 'section',
	label: copy?.comments || 'Opmerkingen',
	fields: [
		{
			id: 1,
			parent_id: 6,
			channel: 'input',
			name: 'opmerkingen',
			label: copy?.comments || 'Opmerkingen',
			required: false,
			type: 'textarea',
			placeholder: ''
		}
	]
}

export default commentsData
